/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:49
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-11-01 11:41:49
 */
import React, { FC, useState } from 'react';
import { Tag, Tooltip, Icon } from '@firesoon/antd';
import { FSTagProps } from './interface';
import './index.less';

const Index: FC<FSTagProps> = ({
  children,
  className = '',
  length = 8,
  type = '',
  borderd = false,
  round = false,
  size = 'default',
  closable = false,
  onClose,
  ...rest
}) => {
  const isLongTag = typeof children === 'string' && children.length > length;
  const getClassName = () => {
    let result = `fs-tag fs-tag-size-${size}`;

    if (type) {
      result = `${result} fs-tag-${type}`;
    }

    if (!borderd) {
      result = `${result} fs-tag-no-border`;
    }

    if (round) {
      result = `${result} fs-tag-round`;
    }

    if (className) {
      result = `${result} ${className}`;
    }

    return result;
  };

  const [visible, setVisible] = useState(true);

  const tagElem = (
    <Tag className={getClassName()} visible={visible} {...rest}>
      {isLongTag && typeof children === 'string' ? `${children.slice(0, length)}...` : children}
      {type === 'link' && <Icon type="right" style={{ marginLeft: 4 }} />}
      {closable && (
        <Icon
          className="tag-close"
          type="close-circle"
          theme="filled"
          onClick={() => {
            setVisible(false);
            onClose?.();
          }}
        />
      )}
    </Tag>
  );

  return isLongTag ? <Tooltip title={children}>{tagElem}</Tooltip> : tagElem;
};

export default Index;
